<!--  -->
<template>
  <div>
    <div>
      <vxe-modal
          v-model="editReceivingModal"
          width="1000"
          class="uploadListCss"
          height="600"
          position="center"
          title="上传附件"
          destroy-on-close
      >
        <p slot="title" style="font-size:18px;font-weight:600">
          <span>上传附件</span>
        </p>
        <div class="flexCss">
          <!--          上传-->
          <div class="uploadCss">
            <Upload
                type="drag"
                :before-upload="beforeOssUpload" :on-success="handleSuccess" action="#" name="recoad"
                :on-progress="handleProgress"
                accept="application/zip"
            >
              <div style="padding: 120px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击上传附件</p>
                <p>仅支持<span style="color: red">zip</span>压缩包文件</p>
                <p>文件大小不超过100M</p>
              </div>
            </Upload>
            <p style="margin-top: 10px">注意事项：根据物流单号、结算确认编号、收付款编号、发票编号</p>
            <p>唯一识别。如上传物流附件，附件名称需命名为对应的“物流单号”</p>
            <p>若有多张图片可将图片名称命名为编号-1,编号-2... eg:L12345678-1.png</p>
            <p>压缩包名称请用文件名加横杠加图片张数命名. eg:<span style="color: red">12月物流附件-88.zip</span></p>
          </div>
          <!--          列表-->
          <div class="progressCss">
            <div  v-if="progressList.length>0">
              <span style="
    font-size: 16px;
    opacity: 1;
    font-weight: 600;
">正在上传</span>
              <div v-for="(i, index) in progressList" :key="index">
                <div style="margin-bottom: 10px;">
                  <div style="display: flex;justify-content:space-between">
                    <span style="font-weight: 600" v-if="i.progress!=100">{{ i.file }}</span>
<!--                    <span style="font-weight: 600">{{ i.file }}</span><span v-if="i.progress == 100"-->
<!--                                                                            style="cursor:pointer"-->
<!--                                                                            @click="delProgress(index)">X</span>-->
                  </div>
                  <Progress :percent=i.progress status="active" hide-info style="width: 85%" v-if="i.progress!=100"/>
<!--                  <span v-if="i.progress == 100 && i.uploadType == 0"-->
<!--                        style="margin-left: 10px;cursor:pointer;color: #5CADFF" @click="createOrderImg(index)">提交</span>-->
<!--                  <span v-if="i.progress == 100 && i.uploadType == 1" style="margin-left: 10px; ">提交中</span>-->
<!--                  <span v-if="i.progress == 100 && i.uploadType == 2" style="margin-left: 10px; ">已提交</span>-->

                </div>
                <span v-if="i.progress == -1" style="color: #FE3B3B">上传失败</span><span v-if="i.progress == -1"
                                                                                      style="cursor:pointer"
                                                                                      @click="delProgress(index)">X</span>
<!--                <span v-else-if="i.progress == 100">上传成功</span>-->
                <span  style="color: #539FFF" v-if="i.progress!=100 && i.progress != -1">上传中</span>
              </div>
            </div>
            <div  v-if="ordOssList.length>0">
              <span style="
    font-size: 16px;
    opacity: 1;
    font-weight: 600;
">上传记录</span>
              <div v-for="(i, index) in ordOssList" :key="index">
                <div style="margin-bottom: 10px;">
                  <div style="display: flex;justify-content:space-between">
                    <span style="font-weight: 600">{{ i.file }}</span>
                  </div>
                  <Progress :percent=i.progress status="active" hide-info style="width: 85%"/>
                  <span v-if="i.progress == 100 && i.uploadType == 0"
                        style="margin-left: 10px;cursor:pointer;color: #5CADFF" @click="createOrderImg(index)">提交</span>
                  <span v-if="i.progress == 100 && i.uploadType == 1" style="margin-left: 10px; ">提交中</span>
                  <span v-if="i.progress == 100 && i.uploadType == 2" style="margin-left: 10px; ">已提交</span>
                </div>
              </div>
            </div>
            <div class="person_info_more imageCss" v-if="progressList.length==0 && ordOssList.length==0 ">
              <img src="~assets/images/common/enclosure.png" width="100px"/>
              <span>暂无上传记录</span>
            </div>
            <vxe-pager
                background
                size="small"
                :current-page.sync="currentPage"
                :page-size.sync="pageSize"
                :page-sizes.sync="pageSizes"
                :total="totalResult"
                @page-change="changePage1"
            ></vxe-pager>
            </div>
        </div>


      </vxe-modal>
    </div>
  </div>
</template>

<script>
  import "viewerjs/dist/viewer.css";
  import $api from "@/apiProvider";
  import {hideLoading} from "@/utils/util";

  export default {
    components: {},
    data() {
      return {
        editReceivingModal: false,
        progressList: [],
        ordOssList:[],
        currentPage:1,
        pageSize:7,
        pageSizes:[7],
        totalResult:10,
        listQuery: {
          page: 1,
          rows: 7,
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      changePage1(val) {
        this.listQuery.page = val.currentPage;
        this.getList();
        console.log(`当前页: ${val}`);
      },
      async getList() {
        // var obj = {
        //   page: 1,
        //   rows: 10,
        // }
        let res = await $api.ordOssImg.request('queryOrdOssImgList', this.listQuery);
        if (res.status === 1) {
          this.totalResult = res.data.total;
          this.ordOssList = res.data.rows;
          this.ordOssList.forEach(i => {
            i.file = i.fileName;
            if (i.fileType == 1) {
              i.uploadType = 0
              i.progress = 100
            } else if (i.fileType == 2) {
              i.progress = -1
            } else if (i.fileType == 3) {
              i.uploadType = 2
              i.progress = 100
            }

          })
          console.log(this.ordOssList);
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async updateOssType(obj) {
        let res = await $api.ordOssImg.request('updateOssType', obj);
        if (res.status === 1) {
          this.getList();
        }
      },
      beforeOssUpload(file) {
        this.file = file;
        var obj = {
          file: file.name,
          progress: 45,
          uploadType: 0
        }
        this.progressList.push(obj)
        this.uploads(file, this.progressList.length);

      },
      uploads(file, val) {
        var self = this;

        this.Oss.uploadFile(file).then(res => {
          console.log(res, val)
          this.progressList[val - 1].progress = res.progress
          var obj = {
            fileName: file.name,
            type: 1
          }
          self.updateOssType(obj);

        }).catch(err => {
              console.log(err)
              this.progressList[val - 1].progress = -1
            }
        )
      },
      handleSuccess(response, file, fileList) {
        console.log(response)
      },
      delProgress(val) {
        this.progressList.splice(val, 1);
      },
      async createOrderImg(val) {
        let self = this;
        this.ordOssList[val].uploadType = 1;
        this.$forceUpdate();
        var obj = {
          fileAddrUrl: this.ordOssList[val].file.split('.')[0],
          id: this.ordOssList[val].id
        }
        await $api.ordersSeller.request('createOrderImg', obj).then((res) => {
          if (res.status === 1) {
            this.ordOssList[val].uploadType = 2;
            this.$forceUpdate();
          } else {
            self.ordOssList[val].uploadType = 0;
            self.$forceUpdate();
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error",
            })
          }
        }).catch(function (er) {
          self.ordOssList[val].uploadType = 0;
          self.$forceUpdate();
          console.log(er.response.data.message);
          self.$XModal.alert({
            message: er.response.data.message
                ? er.response.data.message
                : "接口异常",
            status: "error",
          });
          return;
        });
      },
      handleProgress(event, file, fileList) {
        event.target.onprogress = (event) => {
          // event.loaded		已经上传了文件大小
          // event.total		上传文件总大小
          let uploadPercent = ((event.loaded / event.total) * 100).toFixed(1) + '%'
          console.log(uploadPercent)
        }
      },
      editReceiving() {
        this.editReceivingModal = true;
      },
    }
  };
</script>
<style>
  .person_info_more {
    display: flex;
    align-items: center; /*垂直居中*/
    justify-content: center; /*水平居中*/

  }

  .flexCss {
    display: flex;
  }

  .imageCss {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .progressCss {
    width: 50%;
    padding: 0 20px;
  }

  .uploadCss {
    width: 50%;
  }

  .more {
    width: 14px;
    height: 24px;
  }

  .uploadListCss .vxe-modal--body, .uploadListCss.vxe-modal--wrapper.type--modal .vxe-modal--body .vxe-modal--content {
    overflow: auto;
    padding: 14px;
  }
</style>